<div class="background">
  <div class="window">
    <div class="title">
      <eps-icon [icon]="icon" *ngIf="icon"></eps-icon>
      <span class="part1">{{titlePart1 | translate}}</span> <span class="part2">{{titlePart2 | translate}}</span>
    </div>
    <div class="content">
      <div class="body">
        <ng-content></ng-content>
      </div>
      <div class="buttons">
        <ng-content select="[buttons]"></ng-content>
      </div>
    </div>
  </div>
</div>
